var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { memo, useEffect } from 'react';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { useApplicationState } from 'root/src/client/v2/userData/hooks/useApplicationState';
import { SatisfactionSurveyForm } from 'root/src/client/v2/survey/components/SatisfactionSurveyForm';
import { surveyEndpointIds } from 'root/src/shared/survey/constants';
import { useDareDropApi } from 'root/src/client/v2/common/hooks/useDareDropApi';
export const SatisfactionSurveyModal = memo(() => {
    const modal = useModal();
    const { applicationState } = useApplicationState();
    const { fetcher } = useDareDropApi();
    const onClose = () => __awaiter(void 0, void 0, void 0, function* () {
        yield fetcher({
            endpointId: surveyEndpointIds.IGNORE_SATISFACTION_SURVEY,
        });
    });
    const onHide = () => {
        modal.hide();
    };
    const onShow = () => {
        modal.show(<SatisfactionSurveyModalComponent onHide={onHide} modal={modal}/>, { onClose });
    };
    useEffect(() => {
        if (applicationState === null || applicationState === void 0 ? void 0 : applicationState.isSatisfactionSurveyToDisplay) {
            onShow();
        }
    }, [applicationState === null || applicationState === void 0 ? void 0 : applicationState.isSatisfactionSurveyToDisplay]);
    return null;
});
const SatisfactionSurveyModalComponent = ({ onHide }) => {
    return (<ModalLayout className="sm:w-[600px] px-0 sm:px-0">
			<SatisfactionSurveyForm callback={onHide}/>
		</ModalLayout>);
};
